<template>
  <div class="view">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>企业开机启动规则
    </div>
    <div class="content contentBody rule-body-text">
      <p>
        <span>1、</span><span>您承诺遵守 <em class="checkagreement" @click="dialogVisible=true">《云知服务协议》</em>，保证所上传之自定义企业开机启动图不违反任何国家法律法规政策，不侵犯任何第三方的合法权益，不存在违反社会公序良俗的情况，否则将承担全部责任；</span>
      </p>
      <p>
        <span>2、</span><span>您同意，造像时代有权自行判断并对涉嫌违反本规则的图片随时予以删除，并对您依据<em class="checkagreement" @click="dialogVisible=true">《云知服务协议》</em>及造像时代相关规则进行处罚，包括但不限于权限限制等；</span>
      </p>
      <p>
        <span>3、</span><span>您同意，造像时代有权基于运营及管理需要随时停止提供”自定义企业开机启动图“服务，或者以造像时代通用或个性化开机启动图予以替代；</span>
      </p>
      <p>
        <span>4、</span><span>造像时代有权根据运营及管理需要随时对《自定义企业开机启动图规则》进行增补、修订，如您不接受相关增补修订，将不能使用相关服务。</span>
      </p>
    </div>
    <el-dialog title="云知服务协议" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
      <div class="dialog_conwrap">
        <iframe id="show-iframe"  frameborder=0 name="showHere" scrolling=auto src="/companyadmin/show/agreement.html"></iframe>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    name: "miniappPannel",
    data() {
      return {
        dialogVisible:false
      };
    },
    created() {
    },
    methods: {
      InitFn() {
      },
      goback() {
        this.$router.go(-1);
      }
    }
  };
</script>
